import { UserRole } from '@/types/user-role';

export const determineUserRole = (isOwner: boolean): UserRole => {
  if (isOwner) {
    return 'owner';
  }
  return 'admin';
};
